$(() => {
  let isChanged = false;
  $('.watch-changes').on('change', function () {
    isChanged = true;
  });

  $('.confirm-leave').on('click', function () {
    if (isChanged) {
      event.preventDefault();
      $($(this).data('target-link')).attr('href', $(this).attr('href'));
      $($(this).data('target-modal')).modal('show');
    }
  });
});
